export default "__VITE_ASSET__Ds86WqFh__"